import { QueryClientProvider } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'

import { createQueryClient } from './query-client'

export function QueryProvider({ children }: { children: ReactNode }) {
  // Created once per mount so a Fast Refresh cycle cannot swap the cache.
  const [client] = useState(createQueryClient)

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}
